import { defineStore } from 'pinia';
import { reactive } from 'vue';

export const useFilterStore = defineStore('filters', () => {
    const selectedFilters = reactive<Record<string, string>>({});

    return { selectedFilters };
});
